module.exports = __webpack_public_path__ + "static/media/shape1_3.a057bc68.obj";